/**
 * Authors: mariushirjanu
 * Created: 25/01/2021
 */
import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

const GA1_IFRAME_ID: string = 'ga1ContentDialogFrame';

@Component({
  selector: 'ga1-dialog',
  template: `
    <h3 *ngIf="loading"><activity-indicator></activity-indicator></h3>
    <div class="ga-iframe-container" #iframe></div>
  `,
  styles: [
    '.ga-iframe-container { display: block; height: 100%; }'
  ],
  encapsulation: ViewEncapsulation.None
})
export class Ga1DialogComponent implements OnInit, AfterViewInit {
  @ViewChild('iframe') public iframe:ElementRef;

  // dialog options
  @Input() public url:string;
  public loading: boolean;

  constructor() {
    /***/
  }

  public ngOnInit(): void {
    this.loading = true;
  }

  public ngAfterViewInit(): void {
    // we create iframe element here to improve performance when showing iframe in dialog
    // lazy loading it after angular initial digestion is done
    // this is to prevent DOM render being blocked while iframe loading its content
    const container: HTMLElement = this.iframe.nativeElement;
    const iframe: HTMLElementTagNameMap['iframe'] = document.createElement('iframe');
    iframe.setAttribute('id', GA1_IFRAME_ID);
    iframe.setAttribute('width', '100%');
    iframe.setAttribute('height', 'auto');
    iframe.setAttribute('src', this.url);
    iframe.setAttribute('frameBorder', '0');

    // add event listener when iframe DOM has been loaded
    iframe.addEventListener('load', this.onLoadDone);

    // append to container reference
    container.appendChild(iframe);
  }

  public onLoadDone = (): void => {
    this.loading = false;
  };
}